import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { t } from "i18next";

import React from "react";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
        ref={ref}
        value={value}
        onClick={onClick}
        placeholder="Chọn ngày"
        style={{
            height: "40px",
            padding: "0 10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            outline: "none",
            fontSize: "14px",
            color: "#333",
            backgroundColor: "#fff",
            width: "120px",
            textAlign: "center",
            cursor: "pointer"
        }}
        readOnly
    />
));

function HistoryCasino() {
    function formatDateGame(timeStr) {
        if (!timeStr) return "";
        var m = new Date(timeStr);
        m.setHours(m.getHours() - 1);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2) +
            ":" +
            ("0" + m.getSeconds()).slice(-2);
        return dateString;
    }

    const [data, setData] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 7);
        return d;
    });
    const [endDate, setEndDate] = useState(() => new Date());
    const [searched, setSearched] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 12;
    const typingTimeoutRef = useRef(null);

    const [totalBet, setTotalBet] = useState(0);
    const [totalWin, setTotalWin] = useState(0);
    const [totalProfit, setTotalProfit] = useState(0);
    const [isGuideOpen, setIsGuideOpen] = useState(false);

    const [selectedSanh, setSelectedSanh] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [idPhien, setIdPhien] = useState("");
    const [activePreset, setActivePreset] = useState("all");

    const setDatePreset = (preset) => {
        const today = new Date();
        setPage(1);
        setActivePreset(preset);
        switch (preset) {
            case "today": {
                const start = new Date(today);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "yesterday": {
                const start = new Date(today);
                start.setDate(today.getDate() - 1);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "thisWeek": {
                const start = new Date(today);
                const day = today.getDay();
                const diff = today.getDate() - day + (day === 0 ? -6 : 1);
                start.setDate(diff);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "thisMonth": {
                const start = new Date(today.getFullYear(), today.getMonth(), 1);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "lastMonth": {
                const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const end = new Date(today.getFullYear(), today.getMonth(), 0);
                setStartDate(start);
                setEndDate(end);
                break;
            }
            case "all":
            default: {
                setStartDate(null);
                setEndDate(null);
                break;
            }
        }
    };

    // Timezone-safe local date formatter (YYYY-MM-DD)
    const formatLocalDate = (date) => {
        if (!date) return "";
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        return localDate.toISOString().split('T')[0];
    };

    const fetchHistory = () => {
        setLoading(true);
        const startStr = formatLocalDate(startDate);
        const endStr = formatLocalDate(endDate);
        const payload = {
            startDate: startStr,
            endDate: endStr,
            page: page,
            limit: limit,
            search: searched,
            sanh: selectedSanh,
            category: selectedCategory,
            idPhien: idPhien
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/history`, payload)
            .then((res) => {
                setData(res.data.data.rows || []);
                if (res.data.data.totalPages) {
                    setTotalPages(res.data.data.totalPages);
                }
                const betSum = Number(res.data.data.sums?.betAmount ?? 0);
                const winSum = Number(res.data.data.sums?.winAmount ?? 0);
                setTotalBet(betSum);
                setTotalWin(winSum);
                setTotalProfit(winSum - betSum);
                setLoading(false);
            })
            .catch((err) => {
                setData([]);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, startDate, endDate, searched, selectedSanh, selectedCategory, idPhien]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        
        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1); // Reset về trang 1
        }, 500);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            py: 1
                        }}>
                        {isLoading ? (
                            <div className="loading" style={{ maxWidth: "100%" }}>
                                <div className="loader"></div>
                            </div>
                        ) : null}
                        <Container maxWidth={false}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                                <div className="container_set" style={{ margin: 0 }}>Lịch sử API (Casino)</div>
                                <button className="ax-guide-button" onClick={() => setIsGuideOpen(true)}>
                                    Hướng dẫn <span>❓</span>
                                </button>
                            </Box>

                            {/* Top Stats Cards - AX68WIN Style (Lợi nhuận game API) */}
                            <div className="ax-white-card-row">
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title" style={{ color: "#1565c0", fontWeight: 700 }}>Tổng cược</div>
                                        <div className="ax-card-number" style={{ color: "#1565c0", fontWeight: 800 }}>{Math.floor(totalBet || 0).toLocaleString("vi-VN")}</div>
                                    </div>
                                    <div className="ax-card-icon blue">💲</div>
                                </div>
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title" style={{ color: "#2e7d32", fontWeight: 700 }}>Tổng thắng</div>
                                        <div className="ax-card-number" style={{ color: "#2e7d32", fontWeight: 800 }}>{Math.floor(totalWin || 0).toLocaleString("vi-VN")}</div>
                                    </div>
                                    <div className="ax-card-icon green">🏆</div>
                                </div>
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title" style={{ color: "#c62828", fontWeight: 700 }}>Tổng thua</div>
                                        <div className="ax-card-number" style={{ color: "#c62828", fontWeight: 800 }}>{Math.floor(totalBet - totalWin > 0 ? totalBet - totalWin : 0).toLocaleString("vi-VN")}</div>
                                    </div>
                                    <div className="ax-card-icon red">📈</div>
                                </div>
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title" style={{ color: totalBet - totalWin >= 0 ? "#2e7d32" : "#c62828", fontWeight: 700 }}>Lợi nhuận nhà cái</div>
                                        <div className="ax-card-number" style={{ color: totalBet - totalWin >= 0 ? "#2e7d32" : "#c62828", fontWeight: 800 }}>
                                            {Math.floor(totalBet - totalWin).toLocaleString("vi-VN")}
                                        </div>
                                    </div>
                                    <div className="ax-card-icon green">💰</div>
                                </div>
                            </div>

                            {/* Filter Container - AX68WIN Style (Full Filters matching HistoryBetAll) */}
                            <div className="ax-filter-block">
                                <div className="ax-filter-grid">
                                    <div className="ax-filter-item" style={{ minWidth: "320px" }}>
                                        <label>📅 Khoảng thời gian</label>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                            <div className="ax-date-range">
                                                <DatePicker
                                                    maxDate={new Date()}
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setStartDate(date);
                                                        setPage(1);
                                                    }}
                                                    customInput={<CustomDateInput />}
                                                />
                                                <span style={{ color: "#888" }}>→</span>
                                                <DatePicker
                                                    maxDate={new Date()}
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        setEndDate(date);
                                                        setPage(1);
                                                    }}
                                                    customInput={<CustomDateInput />}
                                                />
                                            </div>
                                            <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginTop: "4px" }}>
                                                {[
                                                    { key: "all", label: "Tất cả ngày" },
                                                    { key: "today", label: "Hôm nay" },
                                                    { key: "yesterday", label: "Hôm qua" },
                                                    { key: "thisWeek", label: "Tuần này" },
                                                    { key: "thisMonth", label: "Tháng này" },
                                                    { key: "lastMonth", label: "Tháng trước" }
                                                ].map((btn) => (
                                                    <button
                                                        key={btn.key}
                                                        type="button"
                                                        onClick={() => setDatePreset(btn.key)}
                                                        style={{
                                                            padding: "5px 12px",
                                                            fontSize: "12px",
                                                            borderRadius: "6px",
                                                            border: activePreset === btn.key ? "1px solid #1890ff" : "1px solid #d9d9d9",
                                                            background: activePreset === btn.key ? "#1890ff" : "#ffffff",
                                                            color: activePreset === btn.key ? "#ffffff" : "#1890ff",
                                                            fontWeight: activePreset === btn.key ? 700 : 600,
                                                            cursor: "pointer",
                                                            boxShadow: activePreset === btn.key ? "0 2px 6px rgba(24,144,255,0.35)" : "none",
                                                            transition: "all 0.2s"
                                                        }}
                                                    >
                                                        {btn.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ax-filter-item">
                                        <label>🏢 Sảnh</label>
                                        <select
                                            value={selectedSanh}
                                            onChange={(e) => {
                                                setSelectedSanh(e.target.value);
                                                setPage(1);
                                            }}
                                            style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                        >
                                            <option value="">Toàn bộ</option>
                                            <option value="AE SEXY">AE SEXY</option>
                                            <option value="DREAM GAMING">DREAM GAMING</option>
                                            <option value="PG SOFT">PG SOFT</option>
                                            <option value="JILI">JILI</option>
                                            <option value="FA CHAI">FA CHAI</option>
                                            <option value="DIGMAAN">DIGMAAN</option>
                                            <option value="MG PLUS">MG PLUS</option>
                                            <option value="PLAYSTAR">PLAYSTAR</option>
                                            <option value="TP">TP</option>
                                        </select>
                                    </div>

                                    <div className="ax-filter-item">
                                        <label>🎭 Thể loại</label>
                                        <select
                                            value={selectedCategory}
                                            onChange={(e) => {
                                                setSelectedCategory(e.target.value);
                                                setPage(1);
                                            }}
                                            style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                        >
                                            <option value="">Toàn bộ</option>
                                            <option value="Casino">Casino</option>
                                            <option value="Nổ hũ">Nổ hũ / Slot</option>
                                            <option value="Bắn cá">Bắn cá</option>
                                            <option value="Đá gà">Đá gà</option>
                                            <option value="Thể thao">Thể thao</option>
                                            <option value="Game bài">Game bài</option>
                                        </select>
                                    </div>

                                    <div className="ax-filter-item">
                                        <label>👤 Tên người chơi</label>
                                        <input
                                            type="text"
                                            placeholder="Tên người chơi"
                                            onChange={handleSearchChange}
                                            style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                        />
                                    </div>

                                    <div className="ax-filter-item">
                                        <label>🔢 ID phiên / Mã cược</label>
                                        <input
                                            type="text"
                                            placeholder="ID phiên"
                                            value={idPhien}
                                            onChange={(e) => {
                                                setIdPhien(e.target.value);
                                                setPage(1);
                                            }}
                                            style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                        />
                                    </div>

                                    <div className="ax-filter-item" style={{ display: "flex", alignItems: "flex-end" }}>
                                        <button className="ax-btn-search-red" onClick={() => { setPage(1); fetchHistory(); }} style={{ height: "40px" }}>
                                            🔍 Tìm kiếm
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="ax-table-wrapper">
                                    <Table>
                                        <TableHead sx={{ backgroundColor: "#FF0000" }}>
                                            <TableRow>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>ID</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>TÊN TÀI KHOẢN</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>TIỀN CƯỢC</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>TIỀN THẮNG</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>LỢI NHUẬN</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>GAME</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>THỂ LOẠI</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important" }}>THỜI GIAN</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {data != null && data.length > 0 ? (
                                            <TableBody>
                                                {data.map((item, idx) => {
                                                    const bet = Number(item?.betAmount || 0);
                                                    const win = Number(item?.winAmount || 0);
                                                    const profit = bet - win;
                                                    return (
                                                        <TableRow key={item?.betOrderNo || idx}>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.betOrderNo}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.username ? (item.username.startsWith('u') ? item.username.substring(1) : item.username) : ""}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px", color: "#1565c0" }}>{bet.toLocaleString("vi-VN")}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px", color: "#2e7d32" }}>{win.toLocaleString("vi-VN")}</TableCell>
                                                            <TableCell sx={{ fontWeight: "700", padding: "10px", color: profit >= 0 ? "#2e7d32" : "#c62828" }}>
                                                                {profit >= 0 ? "+" : ""}{profit.toLocaleString("vi-VN")}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.gameName}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.gameCategory}</TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{formatDateGame(item?.betTime || item?.transactionTime)}</TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={8} align="center">{t("empty")}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )}
                                    </Table>
                                    </div>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    pt: 3
                                }}>
                                {data != null ? <Pagination color="primary" page={page} count={totalPages} size="small" onChange={handleChangePage} /> : null}
                            </Box>
                        </Container>
                    </Box>

                    {/* AX68WIN HƯỚNG DẪN CHI TIẾT MODAL */}
                    {isGuideOpen && (
                        <div className="ax-modal-overlay" onClick={() => setIsGuideOpen(false)}>
                            <div className="ax-modal-card" onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header">
                                    <h3>Hướng dẫn chi tiết</h3>
                                    <span className="close-icon" onClick={() => setIsGuideOpen(false)}>✕</span>
                                </div>
                                <div className="ax-modal-body">
                                    <h4>Khoảng thời gian</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với thời gian đã chọn.</li>
                                    </ul>

                                    <h4>Tên người chơi</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Tên người chơi' đã nhập vào ô văn bản.</li>
                                    </ul>
                                </div>
                                <div className="ax-modal-footer">
                                    <button className="ax-btn-modal-close" onClick={() => setIsGuideOpen(false)}>
                                        Đóng
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}

export default HistoryCasino;
